import React from 'react';
import colors from 'resources/colors';
import { useIntl } from 'react-intl';
import msgId from 'resources/intl';
import { FileUplod } from 'components/FileUpload';
import { useDispatch } from 'react-redux';
import { Box, styled, Typography } from '@mui/material';
import { MultiLineTypography } from 'components/MultiLineTypography';
import AppLogger from 'utils/AppLogger';
import { theme } from 'resources/theme';
import { ContentsHeader } from 'components/ContentsHeader';
import {
  uploadSensorDiagnosisThresholds,
  useSystemSettingsSensorDiagnosisThresholdsError,
  setSensorDiagnosisThresholdsError,
} from '../systemSettingsSlice';
import { CustomScrollBars } from 'components/CustomScrollBars';

const MenuContents = styled('div')({
  paddingBottom: theme.spacing(1),
  minWidth: '200px',
});

const MenuHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '4px 4px 4px 8px',
  border: '1px solid rgba(164, 175, 183, 1)',
  background: colors.listItem.header,
});

interface SensorDiagnosisThresholdsManagementProps {
  open: boolean;
}

export function SensorDiagnosisThresholdsManagement(
  props: SensorDiagnosisThresholdsManagementProps
): JSX.Element {
  AppLogger.debug('CALL: SensorDiagnosisThresholdsManagement');
  const { open } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const sensorDiagnosisThresholdsError = useSystemSettingsSensorDiagnosisThresholdsError();

  const handleAttachFileSensorDiagnosisThresholds = (file: File | undefined) => {
    // 拡張子チェック
    const error = file != null && !file.name.toLowerCase().endsWith('.csv');
    dispatch(setSensorDiagnosisThresholdsError(error));
  };

  const handleUploadSensorDiagnosisThresholds = (file: File) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const url = reader.result as string;
        const data = url.replace(/^.*,/, '');
        dispatch(uploadSensorDiagnosisThresholds(data));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: colors.subDrawer.background,
        visibility: open ? 'visible' : 'hidden',
      }}
    >
      <CustomScrollBars thumbColor={colors.scrollBar.thumb.light}>
        <ContentsHeader
          title={intl.formatMessage({ id: msgId.sensorDiagnosisThresholdsManagement })}
        />
        <MenuContents>
          <MenuHeader>
            <Typography variant="body2" noWrap>
              {intl.formatMessage({ id: msgId.sensorDiagnosisThresholdsSettings })}
            </Typography>
          </MenuHeader>
          <MultiLineTypography
            text={intl.formatMessage({ id: msgId.sensorDiagnosisThresholdsDescription })}
            variant="body2"
            align="left"
            sx={{ padding: '4px 4px 4px 8px' }}
          />
          <FileUplod
            id="FileUplodSensorDiagnosisThresholds"
            acceptFileType=".csv"
            onAttachFile={handleAttachFileSensorDiagnosisThresholds}
            onUpload={handleUploadSensorDiagnosisThresholds}
            errorMessage={
              sensorDiagnosisThresholdsError
                ? intl.formatMessage({ id: msgId.fileIsNotSupported })
                : undefined
            }
            sx={{ marginRight: '8px' }}
          />
        </MenuContents>
      </CustomScrollBars>
    </Box>
  );
}
